import Api from '@/service/Api'


const USER_API_URL = "/api/Controllers";


class SiteService 
{

  get() {
    return Api().post(`${USER_API_URL}/aboutcrud.php`, { opcion: 5 })
  }
  
}

class AboutService 
{

  getVideo() {
    return Api().post(`${USER_API_URL}/aboutcrud.php`, { opcion: 1 })
  }
  
}

export default new AboutService();
